import React from 'react';
import { Input, InputProps } from '@fx-ui/fine-design';
import { parseNumber, str2num } from '@libs/shared';

interface MemberFieldNumberProps extends Omit<InputProps, 'type' | 'onChange'> {
    onChange?: (value: number | null) => void;
}

const MemberFieldNumber: React.FC<MemberFieldNumberProps> = (props) => {
    const { value, onChange, ...otherProps } = props;

    return (
        <Input
            type="number"
            value={parseNumber(value) ?? ''}
            onChange={(value) => onChange?.(str2num(value))}
            {...otherProps}
        />
    );
};

export default MemberFieldNumber;
